import { useQuery } from "react-query";
import { getBrandVerifiedQaGroupsByTaskKey } from "components/attributes/lib/attribute-data";
import { attributeUUID } from "shared/attribute-uuid";

export const useAllBVAttributeGroups = (taskKey) => {
    return useQuery({
        queryKey: ["brandVerifiedAttributes", taskKey],
        queryFn: () =>
            getBrandVerifiedQaGroupsByTaskKey(taskKey).then((data) => {
                const brandKey = Object.keys(data.productWips).find((key) => key.includes("_BV")) || {};
                const internalKey = Object.keys(data.productWips).find((key) => !key.includes("_BV")) || {};

                return {
                    groups: data.group.subGroups,
                    values: data.productWips,
                    roles: [
                        {
                            type: "internal",
                            label: "QA Coder",
                            values: data.productWips[internalKey],
                            lastUpdated: data.productWips[internalKey][attributeUUID.updatedOn],
                            updatedBy: data.productWips[internalKey][attributeUUID.updatedBy],
                        },
                        {
                            type: "brand",
                            label: "Supplier Data",
                            values: data.productWips[brandKey],
                            lastUpdated: data.productWips[brandKey] ? data.productWips[brandKey][attributeUUID.updatedOn] : "",
                            updatedBy: data.productWips[brandKey] ? data.productWips[brandKey][attributeUUID.updatedBy] : "",
                        },
                        { label: "QA Acceptance", type: "qa", values: {} },
                    ],
                };
            }),
    });
};
